'use client';

import Button from '@/components/Button';
import { Box } from '@mui/material';
import { useTranslations } from 'next-intl';
import { ReactNode } from 'react';

export interface WapFooterProps {
  /**
   * 是否显示底部区域
   * @default true
   */
  hasFooter?: boolean;
  /**
   * 底部操作区内容
   */
  footer?: ReactNode;
  /**
   * 确认按钮文本
   * @default 'Ok'
   */
  okText?: string;
  /**
   * 确认按钮是否禁用
   * @default false
   */
  okDisabled?: boolean;
  /**
   * 取消按钮文本
   * @default 'Cancel'
   */
  cancelText?: string;
  /**
   * 确认按钮点击回调
   */
  onOk?: () => void;
  /**
   * 取消按钮点击回调
   */
  onCancel?: () => void;
  /**
   * 是否显示加载状态
   * @default false
   */
  loading?: boolean;
}

const WapFooter = ({
  hasFooter = true,
  footer,
  okText,
  okDisabled = false,
  cancelText,
  onOk,
  onCancel,
  loading = false,
}: WapFooterProps) => {
  const t = useTranslations('dialog');
  const defaultOkText = okText || t('okText');
  const defaultCancelText = cancelText || t('cancelText');

  if (!hasFooter && footer === undefined) {
    return null;
  }

  return (
    <Box
      className="popup-footer fixed z-[10] bottom-0 left-0 right-0"
      sx={{
        padding: '14px 16px',
        // borderTop: '1px solid #f4f4f4',
        boxShadow: '0px -2px 10px 0px rgba(204,204,204,0.5)',
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: 'white',
        gap: '12px',
      }}
    >
      {/* 自定义 footer */}
      {footer !== undefined && footer}

      {/* 双按钮模式：确认 + 取消 */}
      {footer === undefined && onCancel && onOk && (
        <>
          <Button
            variant="outlined"
            fullWidth
            onClick={() => {
              onCancel?.();
            }}
            sx={{
              fontFamily: 'var(--font-bricolage-bold)',
              height: '43px',
            }}
            loading={loading}
          >
            {defaultCancelText}
          </Button>
          <Button
            variant="contained"
            fullWidth
            onClick={onOk}
            sx={{
              fontFamily: 'var(--font-bricolage-bold)',
              height: '43px',
              color: '#fff !important',
            }}
            loading={loading}
            disabled={okDisabled}
          >
            {defaultOkText}
          </Button>
        </>
      )}

      {/* 单按钮模式：只有确认 */}
      {footer === undefined && onOk && !onCancel && (
        <Button
          variant="contained"
          fullWidth
          onClick={onOk}
          sx={{
            fontFamily: 'var(--font-bricolage-bold)',
            height: '43px',
            color: '#fff !important',
          }}
          loading={loading}
          disabled={okDisabled}
        >
          {defaultOkText}
        </Button>
      )}
    </Box>
  );
};

export default WapFooter;
